import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {
  Banner,
  BannerButton,
  BannerFlexWrapper,
} from './../../../components/Banner';

export const GrafanaLinkBanner = ({link}: {link: string}) => {
  return (
    <Banner className="mt-16" variant="announcement">
      <BannerFlexWrapper>
        <Icon name="grafana" />
        <div>
          View a Grafana dashboard for the entire run and its system-level
          detail.
        </div>
        <BannerButton
          eventData={{
            event: 'Banner Button Clicked',
            properties: {
              banner_type: 'Grafana Link Banner',
            },
          }}
          link={link}
          onClick={() => {
            if (!link) {
              console.error('Unable to resolve Grafana dashbaord for run');
            } else {
              // eslint-disable-next-line
              window.open(link, '_blank', 'noopener noreferrer');
            }
          }}
          text="Grafana"
          variant="announcement"
        />
      </BannerFlexWrapper>
    </Banner>
  );
};
